module.exports = __webpack_public_path__ + "img/ContactCardVectors.4c205c22.svg";